import { useState } from 'react'

export function TextEingabe({
  onSpeichern,
  onAbbrechen,
  frage,
}: {
  onSpeichern: (text: string) => Promise<void>
  onAbbrechen: () => void
  /** Die Nachfrage der App, auf die die Notiz antwortet */
  frage?: string
}) {
  const [text, setText] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [laeuft, setLaeuft] = useState(false)

  const speichern = async () => {
    setLaeuft(true)
    try {
      await onSpeichern(text)
    } catch (e) {
      setFehler((e as Error).message)
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <div className="karte eingabe">
      {frage && <p className="leise">Antwort auf: {frage}</p>}
      <textarea autoFocus rows={4} value={text} onChange={(e) => setText(e.target.value)} placeholder={frage ? 'Deine Antwort …' : 'Was möchtest du dir merken?'} />
      {fehler && <p className="fehler">{fehler}</p>}
      <div className="knoepfe">
        <button className="zweitrangig" onClick={onAbbrechen}>
          Abbrechen
        </button>
        <button onClick={speichern} disabled={laeuft || !text.trim()}>
          Speichern
        </button>
      </div>
    </div>
  )
}
